// What a click on a battlefield card should do while the viewer is
// declaring attackers or blockers. Targeting mode is resolved before
// these are consulted, so it is not represented here.
//
// During your own attacker declaration you can only mark your own
// creatures that may attack; during your own block declaration you can
// only pin your own creatures that may block, and only assign them to
// the creatures actually attacking you. Any other battlefield click —
// an enchantment, a summoning-sick creature, the whole opposing board
// while you pick attackers, a non-attacking opponent creature while you
// pick blockers — is off-limits. An off-limits click ("muted") still
// opens the card in the preview so you can read it, but plays the
// warning sound instead of the click chime and gets no green ring.

export type CombatClickIntent =
  | "inspect" // normal inspect: click chime + green ring
  | "muted" // off-limits: preview only, warning sound, no ring
  | "attack" // own creature, toggle attacker mark
  | "block-own" // own creature, pin/toggle as a blocker
  | "block-enemy"; // opponent attacker, assign the pinned blocker

/** Intent for a click on one of the viewer's own battlefield cards. */
export function ownCardClickIntent(opts: {
  showingAttackerPicks: boolean;
  showingBlockPicks: boolean;
  canAttack: boolean;
  canBlock: boolean;
}): CombatClickIntent {
  if (opts.showingAttackerPicks) return opts.canAttack ? "attack" : "muted";
  if (opts.showingBlockPicks) return opts.canBlock ? "block-own" : "muted";
  return "inspect";
}

/** Intent for a click on one of the opponent's battlefield cards. */
export function opponentCardClickIntent(opts: {
  showingAttackerPicks: boolean;
  showingBlockPicks: boolean;
  isIncomingAttacker: boolean;
}): CombatClickIntent {
  if (opts.showingAttackerPicks) return "muted";
  if (opts.showingBlockPicks) {
    return opts.isIncomingAttacker ? "block-enemy" : "muted";
  }
  return "inspect";
}
